export default __webpack_public_path__ + "static/1300-ae0725ec172b22f8e1b20af9f351d7cf.png";